import { registerFeatureMessages, type SupportedLocale } from '@/shared/i18n'

export function registerIntegrationsMessages(locale: SupportedLocale): Promise<void> {
  return registerFeatureMessages('integrations', locale)
}
